// Central theme preset definitions — shared by ThemePicker, ThemePreview, and PublicMenu rendering.
// Each preset is a fully-defined "look" with colors, typography and layout signals.

export const THEME_PRESETS = {
  default: {
    id: "default",
    name: { de: "Standard", en: "Default", tr: "Varsayılan" },
    tagline: { de: "Klassisches lila Branding", en: "Classic purple branding", tr: "Klasik mor marka" },
    bg: "#fafafa",
    bgEnd: "#ffffff",
    surface: "#ffffff",
    text: "#0a0a0a",
    muted: "#71717a",
    border: "#e4e4e7",
    primary: "#9333ea",
    accent: "#a855f7",
    hero: "linear-gradient(135deg,#a855f7 0%,#9333ea 60%,#7e22ce 100%)",
    heroText: "#ffffff",
    fontHeading: "'Outfit', system-ui, sans-serif",
    fontBody: "'Manrope', system-ui, sans-serif",
    headingWeight: 700,
    headingTracking: "-0.02em",
    radius: "1rem",
    btnRadius: "9999px",
    btnStyle: "solid",   // solid | outline | block
    cardStyle: "soft",   // soft | bordered | floating | flat
    layout: "list",      // list | grid | cards
    categoryStyle: "pills", // pills | tabs | sidebar
    priceStyle: "default",
    showHeroImage: true,
    swatches: ["#9333ea", "#fafafa", "#ffffff"],
  },

  dark_luxury: {
    id: "dark_luxury",
    name: { de: "Dark Luxury", en: "Dark Luxury", tr: "Koyu Lüks" },
    tagline: { de: "Edel · Schwarz · Gold", en: "Elegant · Black · Gold", tr: "Şık · Siyah · Altın" },
    bg: "#0a0807",
    bgEnd: "#0a0807",
    surface: "#13100f",
    text: "#fef3c7",
    muted: "#a8956a",
    border: "rgba(245,158,11,0.15)",
    primary: "#f59e0b",
    accent: "#fbbf24",
    hero: "linear-gradient(180deg, rgba(10,8,7,0.4) 0%, rgba(10,8,7,0.95) 100%)",
    heroText: "#fef3c7",
    fontHeading: "'Cormorant Garamond', 'Georgia', serif",
    fontBody: "'Manrope', system-ui, sans-serif",
    headingWeight: 700,
    headingTracking: "-0.01em",
    radius: "1rem",
    btnRadius: "9999px",
    btnStyle: "solid",
    cardStyle: "bordered",
    layout: "list",
    categoryStyle: "pills",
    priceStyle: "gold",
    showHeroImage: true,
    swatches: ["#f59e0b", "#0a0807", "#fef3c7"],
  },

  minimal_cafe: {
    id: "minimal_cafe",
    name: { de: "Minimal Cafe", en: "Minimal Cafe", tr: "Minimal Kafe" },
    tagline: { de: "Skandinavisch · hell · ruhig", en: "Scandinavian · light · calm", tr: "İskandinav · aydınlık · sakin" },
    bg: "#f7f4ee",
    bgEnd: "#f7f4ee",
    surface: "#ffffff",
    text: "#1c1917",
    muted: "#78716c",
    border: "#e7e5e4",
    primary: "#1c1917",
    accent: "#1c1917",
    hero: "none",
    heroText: "#1c1917",
    fontHeading: "'Cormorant Garamond', 'Georgia', serif",
    fontBody: "'Manrope', system-ui, sans-serif",
    headingWeight: 300,
    headingTracking: "-0.02em",
    radius: "1rem",
    btnRadius: "9999px",
    btnStyle: "solid",
    cardStyle: "flat",
    layout: "grid",
    categoryStyle: "tabs",
    priceStyle: "mono",
    showHeroImage: false,
    swatches: ["#1c1917", "#f7f4ee", "#ffffff"],
  },

  steakhouse: {
    id: "steakhouse",
    name: { de: "Steakhouse Premium", en: "Steakhouse Premium", tr: "Steakhouse Premium" },
    tagline: { de: "Kinematisch · Schwarz · Rot", en: "Cinematic · Black · Red", tr: "Sinematik · Siyah · Kırmızı" },
    bg: "#000000",
    bgEnd: "#000000",
    surface: "#0a0a0a",
    text: "#fafafa",
    muted: "#a1a1aa",
    border: "rgba(255,255,255,0.06)",
    primary: "#dc2626",
    accent: "#ef4444",
    hero: "linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.9) 100%)",
    heroText: "#fafafa",
    fontHeading: "'Impact', 'Helvetica Neue', sans-serif",
    fontBody: "'Inter', system-ui, sans-serif",
    headingWeight: 900,
    headingTracking: "-0.04em",
    radius: "0",
    btnRadius: "0",
    btnStyle: "block",
    cardStyle: "bordered",
    layout: "cards",
    categoryStyle: "tabs",
    priceStyle: "impact",
    showHeroImage: true,
    swatches: ["#dc2626", "#000000", "#fafafa"],
  },

  elegant_turkish: {
    id: "elegant_turkish",
    name: { de: "Elegant Turkish", en: "Elegant Turkish", tr: "Şık Türk" },
    tagline: { de: "Warm · Kupfer · Anatolisch", en: "Warm · Copper · Anatolian", tr: "Sıcak · Bakır · Anadolu" },
    bg: "#1a0e0a",
    bgEnd: "#1a0e0a",
    surface: "#22130d",
    text: "#fde9d2",
    muted: "#c8a98a",
    border: "rgba(217,119,6,0.25)",
    primary: "#d97706",
    accent: "#ea580c",
    hero: "linear-gradient(180deg, rgba(26,14,10,0.4), rgba(26,14,10,0.92))",
    heroText: "#fde9d2",
    fontHeading: "'Cormorant Garamond', 'Playfair Display', 'Georgia', serif",
    fontBody: "'Manrope', system-ui, sans-serif",
    headingWeight: 700,
    headingTracking: "-0.01em",
    radius: "1.25rem",
    btnRadius: "9999px",
    btnStyle: "solid",
    cardStyle: "floating",
    layout: "list",
    categoryStyle: "pills",
    priceStyle: "copper",
    showHeroImage: true,
    swatches: ["#d97706", "#1a0e0a", "#fde9d2"],
  },

  modern_neon: {
    id: "modern_neon",
    name: { de: "Modern Neon", en: "Modern Neon", tr: "Modern Neon" },
    tagline: { de: "Futuristisch · Cyan · Magenta", en: "Futuristic · Cyan · Magenta", tr: "Fütüristik · Cyan · Magenta" },
    bg: "#06060a",
    bgEnd: "#06060a",
    surface: "#0c0c14",
    text: "#e0f2fe",
    muted: "#94a3b8",
    border: "rgba(34,211,238,0.25)",
    primary: "#22d3ee",
    accent: "#d946ef",
    hero: "linear-gradient(135deg, rgba(34,211,238,0.25) 0%, rgba(217,70,239,0.25) 100%)",
    heroText: "#e0f2fe",
    fontHeading: "'Outfit', 'Inter', sans-serif",
    fontBody: "'Inter', system-ui, sans-serif",
    headingWeight: 800,
    headingTracking: "-0.03em",
    radius: "1.25rem",
    btnRadius: "0.875rem",
    btnStyle: "outline",
    cardStyle: "floating",
    layout: "cards",
    categoryStyle: "pills",
    priceStyle: "neon",
    showHeroImage: true,
    swatches: ["#22d3ee", "#d946ef", "#06060a"],
  },
};

export const PRESET_ORDER = ["default", "dark_luxury", "minimal_cafe", "steakhouse", "elegant_turkish", "modern_neon"];

export function getPreset(id) {
  return THEME_PRESETS[id] || THEME_PRESETS.default;
}

// Derive CSS variables from a preset → easy to attach to a scope.
export function presetToCssVars(p) {
  return {
    "--qm-bg": p.bg,
    "--qm-bg-end": p.bgEnd,
    "--qm-surface": p.surface,
    "--qm-text": p.text,
    "--qm-muted": p.muted,
    "--qm-border": p.border,
    "--qm-primary": p.primary,
    "--qm-accent": p.accent,
    "--qm-hero": p.hero,
    "--qm-hero-text": p.heroText,
    "--qm-font-heading": p.fontHeading,
    "--qm-font-body": p.fontBody,
    "--qm-radius": p.radius,
    "--qm-btn-radius": p.btnRadius,
  };
}
